import React from 'react'
import styles from '../Interview.module.scss'

type Props = {
  texts: (string | JSX.Element)[]
  name?: string
  color?: 'white'
}

const GreyBox: React.FC<Props> = ({ texts, name, color }) => {
  return (
    <div
      className={color === 'white' ? styles.white_box : styles.grey_box}
    >
      {name && <span className={styles.bold}>{name}</span>}
      {texts.map((text, index) => (
        <React.Fragment key={index}>{typeof text === 'string' ? <p>{text}</p> : text}</React.Fragment>
      ))}
    </div>
  )
}
export default GreyBox
